import { useRef, useState } from "react";
import { toast } from "sonner";
import { Camera, Trash2 } from "lucide-react";
import { API, http, formatApiError } from "../lib/api";

const GOLD = "conic-gradient(from 210deg, #8a6a1f, #f6e3a1, #c9a23f, #fff3c4, #a67c1e, #e9c96b, #8a6a1f)";

export const UserAvatar = ({ u, size = 36, testid, className = "" }) => {
  const [broken, setBroken] = useState(false);
  const photo = u?.avatar_file_id && !broken;
  if (!photo) {
    return (
      <div data-testid={testid} className={`rounded-full text-white grid place-items-center font-bold shrink-0 ${className}`}
        style={{ width: size, height: size, fontSize: size * 0.38, backgroundColor: "var(--brand-primary)" }}>
        {u?.name?.[0]?.toUpperCase() ?? "A"}
      </div>
    );
  }
  return (
    <div data-testid={testid} className={`rounded-full shrink-0 ${className}`}
      style={{ width: size, height: size, padding: Math.max(2, size / 18), background: GOLD, boxShadow: "0 0 0 1px rgba(138,106,31,.35), 0 2px 6px rgba(120,90,20,.35)" }}>
      <img src={`${API}/auth/users/${u.id}/avatar?v=${u.avatar_file_id}`} alt={u.name || ""} onError={() => setBroken(true)}
        className="h-full w-full rounded-full object-cover" style={{ boxShadow: "inset 0 0 0 1px rgba(255,243,196,.6)" }} />
    </div>
  );
};

export const AvatarEditor = ({ uid, u, onChanged }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const upload = async (file) => {
    if (!file) return;
    const fd = new FormData(); fd.append("file", file);
    setBusy(true);
    try { await http.post(`/auth/users/${uid}/avatar`, fd); toast.success("Photo de profil mise à jour"); onChanged?.(); }
    catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); if (ref.current) ref.current.value = ""; }
  };
  const remove = async () => {
    try { await http.delete(`/auth/users/${uid}/avatar`); toast.success("Photo retirée"); onChanged?.(); } catch (e) { toast.error(formatApiError(e)); }
  };
  return (
    <div className="flex items-center gap-4" data-testid="avatar-editor">
      <UserAvatar u={u} size={72} testid="avatar-preview" />
      <div className="space-y-1.5">
        <input ref={ref} type="file" accept="image/png,image/jpeg,image/webp" className="hidden" data-testid="avatar-input" onChange={(e) => upload(e.target.files?.[0])} />
        <button type="button" disabled={busy} onClick={() => ref.current?.click()} data-testid="avatar-upload-btn"
          className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md border border-amber-300 bg-amber-50 text-amber-900 text-xs font-semibold hover:bg-amber-100 transition-colors disabled:opacity-50">
          <Camera className="h-3.5 w-3.5" /> {busy ? "Envoi…" : u?.avatar_file_id ? "Changer la photo" : "Ajouter une photo"}
        </button>
        {u?.avatar_file_id && <button type="button" onClick={remove} data-testid="avatar-remove-btn" className="ml-2 inline-flex items-center gap-1 text-xs text-rose-600 hover:underline"><Trash2 className="h-3.5 w-3.5" /> Retirer</button>}
        <div className="text-[10px] text-slate-500">png, jpg ou webp · 5 Mo max · recadrée en cercle</div>
      </div>
    </div>
  );
};
